export default __webpack_public_path__ + "static/media/logo-header.7c4cc75a.png";